import React, { Component } from "react";
import AgGridTable from "../../../components/common/agGridTable";
import ReadAxios from "../../../components/axiosComponent/read";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { isEmpty } from "lodash";
import { FEATURES } from "../../../utils/constant";

class SKU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: [],
      loadingData: true,
    };
  }

  componentDidMount() {
    ReadAxios({ url: "skuMaster" })
      .then((dataArray) => {
        this.setState({
          rowData: isEmpty(dataArray) ? [] : dataArray.data.resultSet,
          loadingData: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loadingData: false, rowData: [] });
      });
  }

  onCellClicked = (rowData) => {
    if (this.props.permissions.TA_SKU_MASTER.UPDATE == true) {
      typeof rowData.value != 'undefined' && this.onRowEdit(rowData.data);
    }
  }

  onRowEdit = (rowData) => {
    this.props.history.push("/edit-product", {
      ...rowData,
      title: "edit_title",
    });
  };

  onRowDelete = (alert) => {
    if (alert.type === "success") this.props.successAlert(alert);
    else this.props.errorAlert(alert);
    this.props.history.push("/product");
    this.props.history.go();
  };

  render() {
    const { rowData } = this.state;
    const { t } = this.props;
    const Columns = [
      {
        headerName: t("table_header.sku_code") || "Product Code",
        field: "skuCode",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.sku_description") || "Product Description",
        field: "skuDescription",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.sku_name") || "Product Name",
        field: "skuName",
        sortable: true,
        filter: true,
        //hide: true,
      },
      {
        headerName: t("table_header.no_of_units") || "SKU Units",
        field: "noUnitSku",
        sortable: true,
        filter: true,
        //hide: true,
      },
      {
        headerName: t("table_header.sku_type") || "Product Type",
        field: "skuTypeName",
        sortable: true,
        filter: true,
        //hide: true,
      },
      {
        headerName: t("table_header.sku_type_code") || "Product Type Code",
        field: "skuTypeCode",
        sortable: true,
        filter: true,
        //hide: true,
      },
      {
        headerName: t("table_header.product_weight") || "Product Weight",
        field: "weight",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.volume") || "Volume",
        field: "volume",
        sortable: true,
        filter: true,
        //hide: true,
      },
      {
        headerName: t("table_header.height") || "Height",
        field: "height",
        sortable: true,
        filter: true,
        //hide: true,
      },
      {
        headerName: t("table_header.width") || "Width",
        field: "width",
        sortable: true,
        filter: true,
        //hide: true,
      },
      {
        headerName: t("table_header.length") || "Length",
        field: "length",
        sortable: true,
        filter: true,
        //hide: true,
      },
      {
        headerName: t("table_header.net_gross_ratio") || "Net Gross Ratio",
        field: "netgrossRatio",
        sortable: true,
        filter: true,
        //hide: true,
      },
      {
        headerName: t("table_header.gl_code") || "GL Code",
        field: "psLineItemGLCode",
        sortable: true,
        filter: true,
        //hide: true,
      },
      {
        headerName: t("table_header.created_by") || "Created By",
        field: "createdBy",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.created_on") || "Created On",
        field: "createdOn",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.modified_by") || "Modified By",
        field: "updatedBy",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.modified_on") || "Modified On",
        field: "updatedOn",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.edit_delete") || "Edit / Delete",
        field: "edit",
        cellRenderer: "actionRenderer",
        suppressToolPanel: true,
        pinned: "right",
        hide: !this.props.permissions.TA_SKU_MASTER.UPDATE && !this.props.permissions.TA_SKU_MASTER.DELETE,
      },
    ];
    return (
      <React.Fragment>
        <AgGridTable
          isLoading={this.state.loadingData}
          columnDefs={Columns}
          rowData={rowData}
          titleBarTitle={t("title") || "Sku"}
          titleBarLink={"/add-product"}
          baseURL={"skuMaster"}
          pathName={"skuMaster"}
          keyIndex={"skuMasterId"}
          onEdit={this.onRowEdit}
          cellDoubleClicked={this.onCellClicked}
          onDelete={this.onRowDelete}
          hideRowEdit={!this.props.permissions.TA_SKU_MASTER.UPDATE}
          hideRowDelete={!this.props.permissions.TA_SKU_MASTER.DELETE}
          exportHidden={FEATURES.mastersExportDisabled()}
          suppressExcelExport={FEATURES.mastersExportDisabled()}
          suppressCsvExport={FEATURES.mastersExportDisabled()}
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  }
};
const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
    errorAlert: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(translate("sku")(SKU));
